import api from "./api.js";

export default class TermApi {
  static async getList(data) {
    return await api.get(`api/term`, data);
  }

  static async getDetail(id) {
    return await api.get(`api/term/${id}`);
  }
}
